module.exports = __webpack_public_path__ + "assets/PTM75F_W.20cec92d4169e4513f2257b18180cac82107479ca9e40029b9495cd969f57b6b.woff";